import { useAtomValue } from 'jotai'
import { ZoningCodesListContent } from 'src/components/insights/zoning/codes/list'
import { parcelZoning } from 'src/v2/state/owner-reveal/parcel-zoning'

export const ParcelZoningCodesContent = () => {
  const zoning = useAtomValue(parcelZoning)

  return <ZoningCodesListContent details={zoning?.zoneDetails} />
}
